document.addEventListener( 'DOMContentLoaded', function () {

	if ( ! document.querySelectorAll ) {
		return;
	}

	var checkboxes = document.querySelectorAll( '.wpp-option-input input[type="checkbox"]' );
	checkboxes.forEach( function ( checkbox ) {
		checkbox.addEventListener( 'change', function ( e ) {
			var checked = document.querySelectorAll( '.wpp-option-input input[type="checkbox"]:checked' );
			if ( checked.length > 3 ) {
				this.checked = false;
			}
		} );
	} );

} );
